import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_5: FaireProductEntity = {
  token: "ai_bulk_5",
  type: "product",
  name: "Everything Nice Butter Dish",
  brandName: "Ai Bulk Brand",
  imageUrl: "",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description:
    "The Everything Nice Butter Dish adds a bit of elegance to your kitchen counter with smooth ceramic curves.",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
